import { Injectable } from "@angular/core";
import { AuthStateService } from "./auth-state.service";
import { permissions } from "./permissions";

@Injectable({ providedIn: 'root' })
export class RecordPolicyService {

  constructor(private authState: AuthStateService) {}

  can(
    permissionGroup: keyof typeof permissions,
    action: 'read' | 'write' | 'delete',
    options?: {
        status?: number,
        qtdOfRef?: number    }


  ): boolean {

   
   // ✅ Normalize inputs
    const normalizedStatus = options?.status ?? 10;
    const normalizedQtdOfRef = options?.qtdOfRef ?? 0;

    // 1️⃣ PERMISSION CHECK
    // delete is treated as write permission
    const permissionAction = action === 'read' ? 'read' : 'write';

    const requiredRoles = permissions[permissionGroup]?.[permissionAction];
    const isAdmin = this.authState.hasAccess(['Water.Admin']);
    
    if (!this.authState.hasAccess(requiredRoles) && !isAdmin) {
      return false;
    }


    // 2️⃣ BUSINESS RULES   
    // record must be editable
    // ✅ Allow admin to bypass status rule
    if (!isAdmin && (action === 'write' || action === 'delete') &&  normalizedStatus !== 10) {
      return false;
    }

    // delete forbidden if there are references
    if (action === 'delete' && normalizedQtdOfRef > 0) {
      return false;
    }

    return true;
  } 
 

}